import { useState } from 'react';
import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const TileContainer = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-size: ${props => props.backgroundImageSize}%;
  background-image: url(${props => props.backgroundImage});
  background-color: ${props => props.backgroundColor};
  aspect-ratio: 1;
`;

const TileImageHoverable = ({
  children,
  image,
  isMobile,
  onClickTile,
  backgroundImageSize,
  backgroundColor,
  dataFrom,
  dataClick,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const showHoveredContent = !isMobile && isHovering;

  return (
    <TileContainer
      backgroundColor={backgroundColor}
      backgroundImage={image.src}
      backgroundImageSize={backgroundImageSize}
      data-click={dataClick}
      data-from={dataFrom}
      onClick={onClickTile}
      onKeyDown={onClickTile}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      role="button"
      tabIndex={0}
    >
      {showHoveredContent && children}
    </TileContainer>
  );
};

TileImageHoverable.defaultProps = {
  isMobile: false,
  dataFrom: null,
  dataClick: null,
  onClickTile: () => false,
  backgroundImageSize: 100,
  backgroundColor: theme.colors.neutral[100],
};

TileImageHoverable.propTypes = {
  dataFrom: PropTypes.string,
  dataClick: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  image: srcOrNextImageProp.isRequired,
  isMobile: PropTypes.bool,
  onClickTile: PropTypes.func,
  backgroundImageSize: PropTypes.number,
};

export default TileImageHoverable;
